export const unavailableResultsMessage =
  'Search results you are trying to get are no longer available in this session, please run a new search.';
export const socketErrorNumber = 10;
export const socketErrorPattern = "User doesn't have access to specified result set";
